import {createAction, props} from '@ngrx/store';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {MobileBaseIndicationModel, MobileCounterConsumptionModel, MobileCounterListModel, MobileCounterModel} from '../../_models/counters.models';
import {HttpErrorResponse} from '@angular/common/http';

export const LoadList = createAction(
    '[Tenant Counters] Load List',
    props<{ payload: { apartmentId: string, loading: DahLoadingType } }>()
);

export const LoadListSuccess = createAction(
    '[Tenant Counters] Load List Success',
    props<{ payload: { response: MobileCounterListModel } }>()
);

export const LoadListFailure = createAction(
    '[Tenant Counters] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const AddCounter = createAction(
    '[Tenant Counters] Add Counter',
    props<{ payload: { apartmentId: string, counter: MobileCounterModel } }>()
);

export const AddCounterSuccess = createAction(
    '[Tenant Counters] Add Counter Success',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const AddCounterFailure = createAction(
    '[Tenant Counters] Add Counter Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const EditCounter = createAction(
    '[Tenant Counters] Edit Counter',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const EditCounterSuccess = createAction(
    '[Tenant Counters] Edit Counter Success',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const EditCounterFailure = createAction(
    '[Tenant Counters] Edit Counter Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const DeleteCounter = createAction(
    '[Tenant Counters] Delete Counter',
    props<{ payload: { counterId: string } }>()
);

export const DeleteCounterSuccess = createAction(
    '[Tenant Counters] Delete Counter Success',
    props<{ payload: { counterId: string } }>()
);

export const DeleteCounterFailure = createAction(
    '[Tenant Counters] Delete Counter Failure',
    props<{ payload: { error: HttpErrorResponse, counterId: string } }>()
);


export const SendIndication = createAction(
    '[Tenant Counters] Send Indication',
    props<{ payload: { counterId: string, request: MobileBaseIndicationModel, loading: DahLoadingType } }>()
);

export const SendIndicationSuccess = createAction(
    '[Tenant Counters] Send Indication Success',
    props<{ payload: { response: MobileCounterModel } }>()
);

export const SendIndicationFailure = createAction(
    '[Tenant Counters] Send Indication Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const LoadIndication = createAction(
    '[Tenant Counters] Load Indication',
    props<{ payload: { counterId: string, period: string, loading: DahLoadingType } }>()
);

export const LoadIndicationSuccess = createAction(
    '[Tenant Counters] Load Indication Success',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const LoadIndicationFailure = createAction(
    '[Tenant Counters] Load Indication Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const SetOpenedItem = createAction(
    '[Tenant Counters] Set Opened Item',
    props<{ payload: MobileCounterModel }>()
);

export const ClearOpenedItem = createAction(
    '[Tenant Counters] Clear Opened Item'
);


export const AcceptRequest = createAction(
    '[Tenant Counters] Accept Request',
    props<{ counterId: string }>()
);

export const AcceptRequestSuccess = createAction(
    '[Tenant Counters] Accept Request Success',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const AcceptRequestFailure = createAction(
    '[Tenant Counters] Accept Request Failure',
    props<{ payload: HttpErrorResponse, counterId: string }>()
);


export const LoadConsumption = createAction(
    '[Tenant Counters] Load Consumption',
    props<{ payload: { counterId: string, year: number, silent?: boolean } }>()
);

export const LoadConsumptionSuccess = createAction(
    '[Tenant Counters] Load Consumption Success',
    props<{ payload: { consumption: MobileCounterConsumptionModel } }>()
);

export const LoadConsumptionFailure = createAction(
    '[Tenant Counters] Load Consumption Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const IndicationChangedWs = createAction(
    '[Tenant Counters] Indication Changed Ws',
    props<{ payload: { counterId: string, period: string } }>()
);

export const IndicationChangedWsSuccess = createAction(
    '[Tenant Counters] Indication Changed Ws Success',
    props<{ payload: { counter: MobileCounterModel } }>()
);

export const IndicationChangedWsFailure = createAction(
    '[Tenant Counters] Indication Changed Ws Failure',
    props<{ payload: HttpErrorResponse }>()
);


export const UpdateItemWs = createAction(
    '[Tenant Counters] Update Item',
    props<{ payload: { counterId: string } }>()
);
